import axios from 'axios'
import { getCustomerRequest, getCustomerSuccess, getCustomerFail } from '../../../state/redux/slices/customerSlice.js'

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  timeout: 30000,
})

export const fetchCustomer = customerId => async dispatch => {
  try {
    dispatch(getCustomerRequest())
    const token = localStorage.getItem('authToken')
    const response = await api.get(`/v1/admin/buyers/${customerId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
    dispatch(getCustomerSuccess(response.data.data))
  } catch (error) {
    dispatch(getCustomerFail(error.response?.data?.message || error.message))
  }
}

export const createCustomer = teamData => {
  const token = localStorage.getItem('authToken')
  return api.post('/v1/admin/create', teamData, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  })
}
